import { Box, BoxProps, useBreakpointValue } from '@chakra-ui/react';
import { FC } from 'react';

export type VideoBlockProps = {
  src: Record<string, string> | Array<string>;
  type?: 'video/mp4' | 'video/webm';
  srcFallback?: Record<string, string> | Array<string>;
  typeFallback?: 'video/mp4' | 'video/webm';
  loop?: boolean;
} & BoxProps;

const VideoBlock: FC<VideoBlockProps> = ({
  src,
  type,
  srcFallback,
  typeFallback,
  loop = true,
  ...styles
}) => {
  const srcAccordingToBreakpoint = useBreakpointValue(src);
  const srcFallbackAccordingToBreakpoint = useBreakpointValue(srcFallback || {});

  return (
    <Box
      key={srcAccordingToBreakpoint}
      height='full'
      objectFit='cover'
      width='full'
      {...styles}
    >
      <video
        autoPlay
        loop={loop}
        muted
        playsInline
        style={{ minHeight: '100%', minWidth: '100%', objectFit: 'cover' }}
      >
        <source
          src={srcAccordingToBreakpoint}
          type={type}
        />
        {srcFallback && (
          <source
            src={srcFallbackAccordingToBreakpoint}
            type={typeFallback}
          />
        )}
      </video>
    </Box>
  );
};

export default VideoBlock;
